import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, User } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { vendorLabel } from "../lib/api";

const NAV_VENDORS = ["bundles", "electronics", "dyson", "meta_glasses", "shoes", "cologne"];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const { user } = useAuth();

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between gap-6">
        <Link
          to="/"
          data-testid="brand-link"
          className="font-serif italic text-2xl tracking-tight text-white shrink-0"
        >
          ayush<span className="text-white/50">.</span>resellz
        </Link>

        <nav className="hidden lg:flex items-center gap-8 overflow-x-auto">
          <NavLink
            to="/catalog"
            data-testid="nav-catalog"
            className={({ isActive }) =>
              `text-[11px] uppercase tracking-[0.22em] whitespace-nowrap ${isActive ? "text-white" : "text-white/60 hover:text-white"}`
            }
          >
            Catalog
          </NavLink>
          {NAV_VENDORS.map((v) => (
            <NavLink
              key={v}
              to={`/c/${v}`}
              data-testid={`nav-${v}`}
              className={({ isActive }) =>
                `text-[11px] uppercase tracking-[0.22em] whitespace-nowrap ${isActive ? "text-white" : "text-white/60 hover:text-white"}`
              }
            >
              {vendorLabel(v)}
            </NavLink>
          ))}
          <a
            href="https://tiktok.com/@ayush.resellz"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-tiktok"
            className="text-[11px] uppercase tracking-[0.22em] text-white/60 hover:text-white whitespace-nowrap"
          >
            TikTok
          </a>
        </nav>

        <div className="flex items-center gap-4 shrink-0">
          <Link
            to={user?.is_admin ? "/admin" : "/admin/login"}
            data-testid="nav-admin"
            className="hidden md:inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-white/50 hover:text-white"
          >
            <User className="w-4 h-4" />
            {user?.is_admin ? "Admin" : "Sign in"}
          </Link>
          <button
            type="button"
            onClick={() => setOpen(true)}
            data-testid="open-cart-button"
            className="relative inline-flex items-center gap-2 text-white"
          >
            <ShoppingBag className="w-5 h-5" />
            <span className="text-[11px] uppercase tracking-[0.22em] hidden sm:inline">Bag</span>
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-2 -right-3 bg-white text-black text-[10px] font-semibold rounded-full w-5 h-5 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
